import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles/AssignmentFormModal.module.css";
import { Button, Form, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import clsx from "clsx";
import { UploadedItem } from "@components/UploadedItem";
import * as Yup from "yup";
import { InputField, TextArea } from "@components/Input";
import { RichText } from "@components/Input/RichText";
import { AttachmentUploader } from "@components/AttachmentUploader";

const AssignmentFormModal = ({ children, onSubmit, initialValues }) => {
  // state
  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Document title is required")
      .max(100, "Document title require maximum of 100 characters"),
    content: Yup.string().required("Document content is required"),
  });
  // variables
  const [show, setShow] = useState(false);

  // logics before hooks
  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    formik.resetForm();
  };
  // hooks
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
      onSubmit(values);
      handleClose();
    },
  });

  // logics
  const handleUploadAttachment = (attachments) => {
    formik.setFieldValue("attachments", attachments);
    // const listFileLength = event.target.files.length;
    // let files = [];
    // for (let i = 0; i < listFileLength; i++) {
    //   const file = event.target.files[i];
    //   files.push({ name: file.name, file: file, fileUrl: null });
    // }
    // formik.setFieldValue("attachments", [
    //   ...formik.values.attachments,
    //   ...files,
    // ]);
  };

  const handleDeleteAttachment = (index) => {
    const attachments = [...formik.values.attachments];
    attachments.splice(index, 1);
    formik.setFieldValue("attachments", attachments);
  };
  // UI partials
  // effects

  useEffect(() => {
    formik.setValues(initialValues);
  }, [initialValues]);
  // render
  return (
    <>
      <span onClick={handleShow}>{children}</span>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">Add Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={clsx(styles.tabContainer)}>
            <Form>
              <div className="mb-3">
                <InputField
                  name={"title"}
                  type={"text"}
                  label={"Document Title*"}
                  placeholder="Document title here"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  autoComplete="off"
                  touchedValue={formik.touched.title}
                  errorsValue={formik.errors.title}
                />
              </div>

              <Form.Label className="">Content*</Form.Label>
              <Form.Group className="mb-3" controlId="content">
                <RichText
                  name={"content"}
                  value={formik.values.content || ""}
                  onChange={(val) => formik.setFieldValue("content", val)}
                  placeholder={"Content here"}
                  error={"Document content is required"}
                  // error={formik.errors.description}
                  setFieldError={() =>
                    formik.setFieldError(
                      "content",
                      "Document content is required"
                    )
                  }
                  touched={formik.touched.content}
                  setFieldTouched={() =>
                    formik.setFieldTouched("content", true)
                  }
                />
              </Form.Group>

              <AttachmentUploader
                onUploadFinish={handleUploadAttachment}
                initAttachments={formik.values.attachments}
              />
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={formik.handleSubmit}>Save</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

/* required: display name */
AssignmentFormModal.displayName = "AssignmentFormModal";

/* required: props types */
AssignmentFormModal.propTypes = {};

/* required: default props */
AssignmentFormModal.defaultProps = {
  initialValues: { title: "", content: "", attachments: [] },
};

export { AssignmentFormModal };
